import axios from 'axios';

export const PRODUCT_ADDED_TO_TEAM = 'PRODUCT_ADDED_TO_TEAM';

const addProductToTeam = (teamId, product) => (
  (dispatch) => {
    return axios.post(`/api/teams/${teamId}/add-product`, {
      product_id: product.id,
    })
      .then((response) => {
        if (response.status === 204) {
          dispatch({
            type: PRODUCT_ADDED_TO_TEAM,
            teamId,
            product,
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default addProductToTeam;
